// @flow
import type { ExpressParams, FetchFrontendConfigurationResponse } from '@rover/react-lib/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { camelize } from '@rover/utilities/object-utilities';
import { getAxiosInstance } from '@rover/utilities/axiosUtils';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const CONFIGURATION_URL: string = fullApiUrl('frontend/configuration/');

export const SET_LANGUAGE_URL: string = fullApiUrl('i18n/set-language/');

export const get = async (
  expressParams: ?ExpressParams
): Promise<FetchFrontendConfigurationResponse> => {
  const ai = getAxiosInstance(expressParams);

  const params = new URLSearchParams();
  if (process.env.JS_ENV_CLIENT) {
    params.append('path', window.location.pathname);
  } else if (process.env.JS_ENV_SERVER && expressParams) {
    params.append('path', expressParams.req.path);
  }

  try {
    const { data } = await ai.get(CONFIGURATION_URL, { params });
    const camelData = camelize(data, true);
    return camelData;
  } catch (e) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching the frontend configuration.'
    );
  }
};

export const setLanguage = async ({ language }: { language: string }): Promise<void> => {
  const ai = getAxiosInstance();

  try {
    await ai.post(SET_LANGUAGE_URL, { language });
    return Promise.resolve();
  } catch (error) {
    throw DefaultAPIErrorHandler(error, 'There was an error setting your current language');
  }
};

export default { get, setLanguage };



// WEBPACK FOOTER //
// ../react-lib/src/apis/frontendConfiguration.api.js